<script>
  import { calculateEecImage } from '../utils/eecUtil';
  /**
 *
 *
 */
  /**
 *
 */
  let { energyEfficiencyClasses } = $props();

  let isOnlyDevice = Array.isArray(energyEfficiencyClasses) && energyEfficiencyClasses.length === 1;

  const isPopupAvailable = (energyEfficiencyClass) =>
    energyEfficiencyClass.images[0].uriTemplate &&
    (isOnlyDevice || energyEfficiencyClass.component);

  const calculateClasses = (energyEfficiencyClass) => {
    const popupClasses = isPopupAvailable(energyEfficiencyClass)
      ? 'reco_cinema__article-eek-label-img js_openInPaliLayer clickable'
      : '';
    return `${popupClasses}`;
  };

  const getComponentLabel = (component) => {
    if (component) {
      return `<h2 class="reco_cinema__article-eek-layer-title reco_cinema__article-eek-layer-label">${component}</h2>`;
    }
    return '';
  };

  const getDataSheetLabel = (dataSheetHref) => {
    if (dataSheetHref) {
      return `<a class="pl_link100--primary reco_cinema__article-eek-layer-datasheet reco_cinema__article-eek-layer-label"
                        href="${dataSheetHref}" target="_blank" rel="noopener noreferrer" data-target="_blank"><span>Produktdatenblatt (PDF)</span></a>`;
    }
    return '';
  };

  const getLabelHtmlSnippet = (energyEfficiencyClass) => {
    if (!energyEfficiencyClass.images[0].uriTemplate) {
      return '<div class="reco_cinema__article-eek-layer-container"><p class="p_copy100">Aktuell stehen leider keine weiteren Informationen zur Energieeffizienzklasse dieses Artikels zur Verfügung.</p></div>';
    }

    let eekLayerContainer = '<div class="reco_cinema__article-eek-layer-container">';

    const componentLabel = getComponentLabel(energyEfficiencyClass.component);
    const dataSheetLabel = getDataSheetLabel(energyEfficiencyClass.dataSheetHref);

    if (componentLabel || dataSheetLabel) {
      eekLayerContainer += `<div class="reco_cinema__article-eek-layer-labels-container">${componentLabel}${dataSheetLabel}</div>`;
    }

    eekLayerContainer += `<img src="${energyEfficiencyClass.images[0].uriTemplate}"/> </div>`;
    return eekLayerContainer;
  };
</script>

<div class="reco_cinema__multi-eek-container">
  <div class="reco_cinema__article-eek-container reco_cinema__article-eek">
    {#each energyEfficiencyClasses as energyEfficiencyClass}
      <div class="reco_cinema__article-eek-label oc-mt-25">
        <div
          class={calculateClasses(energyEfficiencyClass)}
          data-layer-content={getLabelHtmlSnippet(energyEfficiencyClass)}
          data-layer-width-l="550px"
          data-layer-width-xl="550px">
          <img
            src="/assets-static/icons/{calculateEecImage(energyEfficiencyClass)}.svg"
            data-testid={calculateEecImage(energyEfficiencyClass)}
            alt="Energieverbrauchskennzeichnung"
            height="20"
            width="35" />
        </div>
        {#if energyEfficiencyClass.dataSheetHref}
          <div class="reco_cinema__article-eek-label_energyLabelText">
            {#if energyEfficiencyClass.displayName}
              <span
                class="oc-copy-50 reco_cinema__article-eek-label_energyLabelText_energyLabelTextComponent">
                {energyEfficiencyClass.displayName}
              </span>
            {/if}
            <a
              href={energyEfficiencyClass.dataSheetHref}
              target="_blank"
              rel="noopener noreferrer"
              class="oc-link-v1 oc-link-v1--size-50 oc-link-v1--secondary reco_cinema__article-eek-label_energyLabelText_datasheet">
              Produktdatenblatt
            </a>
          </div>
        {/if}
      </div>
    {/each}
  </div>
</div>

<style lang="scss">
  .reco_cinema__article-eek-container {
    width: 110px;
    display: flex;
    flex-wrap: wrap;
  }

  .reco_cinema__article-eek-label {
    white-space: nowrap;
    display: flex;
    align-items: center;

    &_energyLabelText {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      &_energyLabelTextComponent {
        cursor: default;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 115px;
        margin-left: 4px;
      }

      &_datasheet {
        margin-left: 4px;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }

  .reco_cinema__article-eek-label:first-of-type {
    margin-top: unset !important;
  }

  .clickable {
    cursor: pointer;
  }

  :global(.reco_cinema__article-eek-layer-container) {
    margin: 16px auto;
    text-align: center;

    :global(.reco_cinema__article-eek-layer-title) {
      font-weight: 400;
      font-size: 20px;
      text-align: left;
      padding-left: 16px;
    }

    :global(.reco_cinema__article-eek-layer-datasheet) {
      text-align: left;
      display: block;
      padding-left: 16px;
    }

    :global(.reco_cinema__article-eek-layer-label) {
      margin-bottom: 16px;
    }

    :global(.reco_cinema__article-eek-layer-labels-container) {
      margin-bottom: 24px;
    }
  }
</style>
